<template>
  <v-card
    class="shop-card"
    :to="{name: 'shop', params: {shopid: shop.id}}"
  >
    <v-img
      :src="shop.image"
      :aspect-ratio="16/9"
    />
    <v-card-title class="title">{{shop.name}}</v-card-title>
    <v-card-subtitle>{{shop.pref}}</v-card-subtitle>
    <v-card-text>
      <div class="shop-info">
        <v-icon>map</v-icon>
        <div class="shop-value">
          <a
            :href="shop.map"
            target="bookin:map"
            @click.stop
          >
            <span>〒{{shop.postal}}</span><br>
            <span>{{shop.address}}</span>
          </a>
        </div>
      </div>
      <div class="shop-info">
        <v-icon>access_time</v-icon>
        <div class="shop-value">
          <span>{{shop.workTime.special}}</span><br>
          <span>休/{{shop.dayOff}}</span>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<style lang="scss">
.shop-card {
  .shop-info {
    display: flex;
    flex-flow: row nowrap;
    align-items: flex-start;
  }

  .shop-value {
    margin-left: 1rem;
    line-height: 1.5rem;
  }
}
</style>

<script>
export default {
  name: 'ShopCard',
  props: {
    shop: {
      type: Object,
      required: true
    }
  }
}
</script>
